import React from 'react';
import { useAppContext } from '../../app/AppContext';
import { PageContainer } from 'shared/components/PageContainer';
import { RentalPageTitleHelmet } from 'rental/components/PageTitleHelmet';
import { SubmitActions } from '../../../shared/components/SubmitActions';
import { PageHeading } from 'shared/components/typography';
import { Summary_ApplicationFragment, useApplicationSummaryQuery } from '../../generated.graphql';
import { RentalStepProps } from 'rental/app/steps';
import { AboutMeSummary } from './SummaryAboutMe';
import { AdditionalInfoSummary } from './SummaryAdditionalInfo';
import { AddressSummary } from './SummaryAddress';
import { AgreementSummary } from './SummaryAgreement';
import { AltContactSummary } from './SummaryAltContact';
import { BankStatementsSummary } from './SummaryBankStatements';
import { CartSummary } from './SummaryCart';
import { IncomeSummary } from './SummaryIncome';
import { PaymentSummary } from './SummaryPayment';
import { SummaryValidationErrors } from '../../../shared/summary/SummaryValidationErrors';


interface Props extends RentalStepProps {
}


export const Summary = (props: Props) => {
  const app = useAppContext();
  const [result] = useApplicationSummaryQuery({variables: {portalSlug: app.portalSlug}});
  const application: Summary_ApplicationFragment | undefined = result.data?.portal?.myApplication ?? undefined;
  const isValid = result.data?.portal?.myApplication?.validation.isValid ?? true;

  return (
    <PageContainer>
      <RentalPageTitleHelmet>Summary</RentalPageTitleHelmet>
      <PageHeading>Application Summary</PageHeading>
      {!isValid && (<SummaryValidationErrors errors={result.data?.portal?.myApplication?.validation.cart ?? []} />)}
      <CartSummary application={application} />
      <AboutMeSummary application={application}
        salutationEnum={result.data?.salutationSourceEnum}
        residentStatusEnum={result.data?.residentStatusEnum} />
      {application?.alternativeContactRequired && <AltContactSummary application={application} />}
      <AddressSummary application={application}
        homeTypeSourceEnum={result.data?.homeTypeSourceEnum} />
      <IncomeSummary application={application}
        workBasisEnum={result.data?.workBasisEnum}
        livingExpensesEnum={result.data?.livingExpensesEnum} 
      />
      {application?.bankStatementsRequired && <BankStatementsSummary application={application} bankStatementsResultEnum={result.data?.bankStatementsResultEnum} />}
      <AdditionalInfoSummary application={application} />
      <PaymentSummary application={application} />
      <AgreementSummary application={application} />
      <SubmitActions
        actions={props.actions}
        disabled={!isValid}
        submit={() => {
          props.onSubmitSuccessful();
        }}
      />
    </PageContainer>
  );
}